import {
  actionTypes as asyncTypes,
  isAsyncOperation,
  isAsyncComplete,
} from "async-ops";
import { GET_PROVIDER_LIST } from "../services/get-provider-list";

export const SET_EMDR_STATUS = "SET_EMDR_STATUS";

const initialState = {
  providerList: [],
  totalCount: 0,
  visible: false,
  message: "",
  isEMDRStatusUpdated: null,
};

export default function(state = initialState, action) {
  switch (action.type) {
    case GET_PROVIDER_LIST:
      const response = action.response;
      return {
        ...state,
        providerList: response.providerList,
        totalCount: response.totalCount,
      };
      case SET_EMDR_STATUS:
        const statusChangeMessage = action.data.message
          ? action.data.message
          : action.data.statusChanged
          ? "EMDR status updated successfully"
          : "Unable to update EMDR status";
      
        const newState = {
          ...state,
          message: statusChangeMessage,
          isEMDRStatusUpdated: action.data.statusChanged,
          visible: (action.data.visible || (action.data.propertySelector === "visible" ? action.data.updatedValue : false)),
        };
      
        return newState;
      
    case asyncTypes.OPERATION:
    case asyncTypes.COMPLETE:
    case asyncTypes.FAILURE:
      if (isAsyncOperation(GET_PROVIDER_LIST)(action)) {
        return {
          ...state,
          providerList: [],
          totalCount: 0,
        };
      }
      if (isAsyncComplete(GET_PROVIDER_LIST)(action)) {
        const response = action.response;
        return {
          ...state,
          providerList: response.providerList,
          totalCount: response.totalCount,
        };
      }
      return state;

    default:
      return state;
  }
}
